import ScrollToTop from '../Components/ScrollToTop';
import Navbar2 from '../Components/Navbar2/index2';
import Login from '../Components/Login/Login';

const LogIn = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar2 />
      <Login />
    </>
  )
}

export default LogIn